import { View } from 'react-native';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { styles } from './VerifyEmail.styles';

export const VerifyEmail = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        Ihre E-Mail-Adresse muss verifiziert werden, bevor Sie neolexon
        verwenden können. Wir haben Ihnen eine E-Mail zur Verifikation gesendet.
        Bei Problemen mit der Verifizierung schreiben Sie bitte eine E-Mail an{' '}
        <TextLink href="mailto:info@neolexon.de">info@neolexon.de</TextLink>.
      </Text>
    </View>
  );
};
